import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-authorization',
  templateUrl: './fh-svg-authorization.component.html',
  styleUrl: './fh-svg-authorization.component.scss'
})
export class FhSvgAuthorizationComponent {
  @Input() color: string = '';
}
